import type { ComputerPartDefId } from './types'

export const COMPUTER_PART_DEF_IDS: readonly ComputerPartDefId[] = [
  'computer-tower-salvage',
  'laptop-salvage',
  'raspberry-pi-salvage',
  'monitor-salvage',
] as const

export function isComputerPartDefId(id: string): id is ComputerPartDefId {
  return (COMPUTER_PART_DEF_IDS as readonly string[]).includes(id)
}

export function computerLabJobDurationMs(partDefId: string): number {
  switch (partDefId) {
    case 'raspberry-pi-salvage':
      return 55_000
    case 'monitor-salvage':
      return 72_000
    case 'laptop-salvage':
      return 88_000
    case 'computer-tower-salvage':
      return 115_000
    default:
      return 90_000
  }
}

/** Stash € band per salvage tier */
export function rollComputerLabTrinketPayout(partDefId: string): number {
  switch (partDefId) {
    case 'raspberry-pi-salvage':
      return 9 + Math.floor(Math.random() * 10)
    case 'monitor-salvage':
      return 12 + Math.floor(Math.random() * 12)
    case 'laptop-salvage':
      return 14 + Math.floor(Math.random() * 14)
    case 'computer-tower-salvage':
      return 16 + Math.floor(Math.random() * 16)
    default:
      return 10 + Math.floor(Math.random() * 12)
  }
}

export function computerLabProgrammingXpAmount(partDefId: string): number {
  switch (partDefId) {
    case 'raspberry-pi-salvage':
      return 10
    case 'monitor-salvage':
      return 12
    case 'laptop-salvage':
      return 14
    case 'computer-tower-salvage':
      return 16
    default:
      return 11
  }
}
